var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VRow',[(_vm.accessibleCustomerGroups.length > 0)?_c('VCol',{attrs:{"cols":"12","md":"4"}},[_c('VFormBuilder',{ref:"customerGroupForm",attrs:{"items":_vm.customerGroupItems}})],1):_vm._e(),_c('VCol',{attrs:{"cols":"12","md":"8"}},[_c('VFormBuilder',{ref:"dateForm",attrs:{"items":_vm.dateItems}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }